import React from 'react'
// import LogoImg from '../img/deviner.gif'
// import LogoImgJpg from '../img/deviner.jpg'
export default class extends React.Component {
    render() {
        return (
            <div style={{ backgroundColor: 'transparent', padding: '12px' }}>
                {/* <img src={LogoImgJpg} style={{width:'100px',height:'100px',borderRadius:'50%'}}/> */}
            </div>
        )
    }
}